import Axios from "axios";
import { LOCAL_STORAGE } from "../../utils/constants";
import APP_CONSTANTS from '../../config/constants';

export const getDebitNote = async (page) => {
try {
const userId = LOCAL_STORAGE.userId
const token = LOCAL_STORAGE.userToken
const customerNo = LOCAL_STORAGE.customerNo

const { data } = await Axios.get(
`${APP_CONSTANTS.BASE_URL}/purchase/debit-note/getDebitNote?page=${page}`,
{
headers: {
'Accept': 'application/json',
'Content-Type': 'application/json',
'Authorization': token
},
params: {
customerNo: customerNo,
userId: userId,
}
})
return data

} catch (error) { }
}
